import { createClient } from 'urql';
import urljoin from 'url-join';

const makeCLient = () => createClient({
    url: urljoin(process.env.REACT_APP_PUBLIC_URL ?? '', 'graph'),
});

export default makeCLient;